module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "percentage-card-contents"
  }, [_c('div', {
    staticClass: "heading__container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.heading))])]), _vm._v(" "), _c('div', {
    staticClass: "radial__container"
  }, [_c('radial-progress-bar', {
    staticClass: "centered",
    attrs: {
      "progressPercentage": _vm.percentage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "count__container"
  }, [_c('p', {
    staticClass: "callout-text--medium text--center font-condensed"
  }, [_vm._v(_vm._s(_vm.count))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13780882","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/PercentageCardContents/PercentageCardContents.vue
// module id = 535
// module chunks = 1